import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRiderSeries } from '../../services/bookingService';
import { formatPattern } from '../../services/recurringService';
import toast from 'react-hot-toast';
import BackButtonBottom from '../../components/common/BackButtonBottom';

export default function SeriesList() {
  const navigate = useNavigate();
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRiderSeries()
      .then((res) => setSeries(res.series || []))
      .catch((err) => toast.error(err.message || 'Could not load series'))
      .finally(() => setLoading(false));
  }, []);

  const statusBadge = (s) => {
    if (s.status === 'cancelled') return { bg: '#fee2e2', color: '#991b1b', label: 'Cancelled' };
    if (s.fareStatus === 'calculating') return { bg: '#fef3c7', color: '#92400e', label: 'Pricing…' };
    if (s.fareStatus === 'complete') return { bg: 'rgba(45,212,168,0.1)', color: '#059669', label: 'Active' };
    return { bg: '#f1f5f9', color: '#5a6578', label: s.status };
  };

  return (
    <div className="max-w-[700px] mx-auto p-6">
      <div className="flex items-center gap-3 mb-6">
        <button onClick={() => navigate('/rider')} className="bg-transparent border-0 text-brand-primary font-semibold text-[0.9rem] cursor-pointer p-0">← Dashboard</button>
      </div>

      <h1 className="font-serif mt-0 mb-2 text-brand-dark">
        My recurring bookings
      </h1>
      <p className="text-body text-[0.9rem] mb-6">
        Series you've scheduled. Tap a series to see individual trips.
      </p>

      {loading && <div className="p-10 text-center text-muted">Loading...</div>}

      {!loading && series.length === 0 && (
        <div className="p-10 text-center text-muted bg-white rounded-2xl border border-slate-200">
          You haven't created any recurring bookings yet.
          <div className="mt-3">
            <button onClick={() => navigate('/rider/book')} className="px-5 py-2.5 rounded-full border-0 bg-brand-primary text-white cursor-pointer font-semibold">Book a trip</button>
          </div>
        </div>
      )}

      <div className="grid gap-3">
        {series.map((s) => {
          const badge = statusBadge(s);
          return (
            <div
              key={s.id}
              onClick={() => navigate(`/rider/series/${s.id}`)}
              className="p-[18px] rounded-2xl bg-white border border-slate-200 cursor-pointer transition-all"
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#2dd4a8'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div className="flex justify-between items-start mb-1.5">
                <div className="font-bold text-brand-dark text-[1rem]">{s.referenceNumber}</div>
                <span className="px-2.5 py-[3px] rounded-full text-[0.7rem] font-bold" style={{ background: badge.bg, color: badge.color }}>
                  {badge.label}
                </span>
              </div>
              <div className="text-[0.85rem] text-body mb-1">
                {formatPattern(s.pattern)}
              </div>
              <div className="text-[0.8rem] text-muted">
                {s.pickupAddress} → {s.destinationAddress}
              </div>
              <div className="flex gap-3 mt-2 text-[0.78rem] text-body">
                <span>{s.occurrenceCount} occurrences</span>
                {s.fareStatus === 'complete' && (
                  <span>~${s.totalEstimatedFare?.toFixed(2)} total</span>
                )}
                {s.fareStatus === 'calculating' && (
                  <span>Calculating fares… ({s.occurrencesPriced || 0}/{s.occurrenceCount})</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    <BackButtonBottom to="/rider" label="Dashboard" />
    </div>
  );
}